// extracted by mini-css-extract-plugin
export default {"slideContainer":"_69981e0c49 _2a980b9a07 e87fa39adc","slideImage":"_2051735870"};